import React, { forwardRef } from 'react';

import type { ShoesColorsNullableParameter } from '@vlabs/api/luna-api/model';
import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';

import { ColorGridFilter } from '@vlabs/monokit/shared/ui/color-grid-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';

function ShoesColorFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { t } = useEventListFiltersTranslation();
  const { filters, updateFilters } = useEventListFilters();

  const selectedColors = filters.shoes_apparent_colors ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={filters.shoes_apparent_colors === undefined}
      onClickReset={() => updateFilters({ shoes_apparent_colors: undefined })}
      ref={ref}
    >
      <ColorGridFilter
        label={t('shoes_apparent_colors_popover')}
        onChange={(value) => updateFilters({
          shoes_apparent_colors: value.length > 0
            ? (value as unknown as ShoesColorsNullableParameter)
            : undefined,
        })}
        options={EVENT_ENUMS.LOWER_BODY.SHOES.APPARENT_COLOR.raw}
        value={selectedColors}
      />
    </PopoverWithButton>
  );
}

const ShoesColorFilterPopoverWithRef = forwardRef(ShoesColorFilterPopover);
export { ShoesColorFilterPopoverWithRef as ShoesColorFilterPopover };
